/**
 * 评价按钮
 */
import React, { FC } from 'react'
import { useHistoryNew } from '@utils'
import './index.scss'

interface IProps {
  info: any;
}

const OrderCommentBtn: FC<IProps> = (props: IProps) => {
  const { info } = props
  const history = useHistoryNew()

  return (
    <div className='eval-area'>
      <div
        className={`eval-btn ${info.memberOrder?.hasComment && info.memberOrder?.hasReplyComment ? 'has-reply' : ''}`}
        onClick={(e: any) => {
          e.stopPropagation()
          if (info.memberOrder?.hasComment) {
            history.push({
              pathname: `/eval/detail/${info.ordersId}`,
            })
          } else {
            history.push({
              pathname: `/eval/${info.ordersId}`,
            })
          }
        }}
      >
        <div className='eval-icon'>
          <i className='iconfont icon-beizhu'></i>
        </div>
        <span>{info.memberOrder?.hasComment ? i18n.t('mkt.comment.viewComments') : i18n.t('mkt.comment.comment')}</span>
      </div>
    </div>
  )
}

export default OrderCommentBtn
